import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Cultivation Unit List with Query (for remote operations)
export const getCultivationUnitListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_CULTIVATION_UNITS}?${stringifyParams(
			params
		)}`
	);
};

// Get Cultivation Unit List with Query
export const getCultivationUnitList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_CULTIVATION_UNITS}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Cultivation Unit
export const getCultivationUnit = cultivation_unit_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_CULTIVATION_UNIT}${cultivation_unit_id}`
	);
};

// Add New Cultivation Unit
export const addNewCultivationUnitApi = cultivation_unit => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_CULTIVATION_UNIT}`,
		cultivation_unit
	);
};

// Update Cultivation Unit
export const updateCultivationUnitApi = cultivation_unit => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_CULTIVATION_UNIT}${cultivation_unit._id}`,
		cultivation_unit
	);
};

// Delete Cultivation Unit
export const deleteCultivationUnitApi = cultivation_unit_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_CULTIVATION_UNIT}${cultivation_unit_id}`
	);
};

// Check if Cultivation Unit Exists
export const checkCultivationUnitExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_CULTIVATION_UNIT_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
